import { AlertProps, ComponentStyleConfig } from '@chakra-ui/react'

const variantSubtle = ({ status }: AlertProps) => ({
  container: {
    bg: `product.state.subtle.${status}`,
    color: `product.state.solid.${status}`,
  },
  icon: { color: `product.state.solid.${status}` },
})

const variantSolid = ({ status }: AlertProps) => ({
  container: {
    bg: `product.state.solid.${status}`,
    color: 'white',
  },
})

const variantMultiline = ({ status }: AlertProps) => ({
  container: {
    bg: `product.state.subtle.${status}`,
    color: `product.text.state.${status}`,
    borderColor: `product.state.solid.${status}`,
  },
  icon: { color: `product.state.solid.${status}` },
})

export const Alert: ComponentStyleConfig = {
  baseStyle: {
    container: {
      borderRadius: 'base',
      py: 4,
      px: 4,
      fontWeight: '400',
    },
    title: {
      fontWeight: '600',
    },
  },
  variants: {
    outline: ({ colorScheme }: { colorScheme: string }) => {
      return {
        container: {
          border: '1px solid',
          borderColor: `${colorScheme}.700`,
          color: `${colorScheme}.700`,
          bg: `${colorScheme}.50`,
        },
      }
    },
    subtle: variantSubtle,
    solid: variantSolid,
    multiline: variantMultiline,
  },
}
